import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { parseEmptyArray, isEmptyArray } from '@common/helpers';
import { PassengerInformationInputModalEditArea } from '@common/helpers/constants/my-booking/passenger-information-input-modal.constant';
import { MListData } from '@common/interfaces';
import { ServicingCommonStoreService } from '@common/services';
import { MyBookingPassengerService } from '@common/services/my-booking/my-booking-passenger/my-booking-passenger.service';
import { SupportComponent } from '@lib/components/support-class';
import { StaticMsgPipe } from '@lib/pipes';
import { AswMasterService, CommonLibService } from '@lib/services';
import { Subscription } from 'rxjs';
import {
  GetOrderResponseData,
  GetOrderResponseDataContacts,
  GetOrderResponseDataContactsRepresentativeEmailsInner,
  GetOrderResponseDataContactsRepresentativePhonesInner,
  GetOrderResponseDataOrderType,
} from 'src/sdk-servicing';

@Component({
  selector: 'asw-representive-contacts',
  templateUrl: './representive-contacts.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RepresentiveContactsComponent extends SupportComponent {
  private _subscriptions: Subscription = new Subscription();

  pnr!: GetOrderResponseData;
  contacts!: GetOrderResponseDataContacts;

  mListData!: MListData[];

  constructor(
    private _common: CommonLibService,
    private _myBookingPassengerService: MyBookingPassengerService,
    private staticMsg: StaticMsgPipe,
    private _servicingCommonStoreService: ServicingCommonStoreService,
    private _change: ChangeDetectorRef
  ) {
    super(_common);
  }

  reload(): void {}

  init(): void {
    this._subscriptions.add(
      this._servicingCommonStoreService.getServicingCommonModel$().subscribe((servicingCommon) => {
        this.pnr = (servicingCommon?.getOrder as GetOrderResponseData) ?? ({} as GetOrderResponseData);
        this.contacts = this.pnr?.contacts ?? [];
        this._change.markForCheck();
      })
    );

    this._subscriptions.add(
      this._myBookingPassengerService.masterDataPassengerAction$.subscribe((masterData) => {
        this.mListData = masterData?.mListData ?? [];
        this._change.markForCheck();
      })
    );
  }

  getResentativePhones() {
    return parseEmptyArray(this.contacts?.representative?.phones);
  }

  // [2.1] 代表者連絡先情報編集
  isDisplayEditContactBtn() {
    return Boolean(this.pnr?.orderEligibilities?.travelerInput?.isEligibleToForward);
  }

  // [2.2] 代表者メールアドレス
  getEmailData(): string {
    // 2. 上記以外の場合、以下の条件に応じた内容を表示する。
    // 2.1. PNR情報取得API応答.data.contacts.representative.emails[]が空である場合、未登録の旨の文言を表示する。
    if (isEmptyArray(this.contacts?.representative?.emails)) {
      return this.staticMsg.transform('label.requestForRegistration');
    }
    // 2.2 上記以外の場合、以下の処理を行う。
    // <以下、PNR情報取得API応答結果data.contacts.representative.emails[]の要素数繰り返し> (それぞれの要素が当該代表者メールアドレス)
    return parseEmptyArray(
      this.contacts?.representative?.emails as GetOrderResponseDataContactsRepresentativeEmailsInner[]
    )
      .filter((email) => email?.address!)
      .map((email) => email?.address)
      .join(' <br>');
  }

  /** a part of [2.2] 代表者メールアドレス */
  isDisplayEmailData() {
    return !this.pnr?.orderType?.isGroupBooking;
  }

  /**1-6 代表者電話番号 */
  // [2.3] 代表者電話番号
  getTelNumber(phone: GetOrderResponseDataContactsRepresentativePhonesInner): string {
    const typePhone = phone?.type ?? '';
    /**
     *  2.2.1 当該代表者電話番号.typeを基に「イベントID(1)」で取得した電話番号種別を取得する。以下の通りとする。
     */
    const type = this._myBookingPassengerService.getTypeInfoFromMLISTDATA(typePhone, this.mListData);
    /** 2.2.1.1 取得できる場合、取得した電話番号種別。 */
    if (type) {
      /** 2.2.2 "電話番号種別 + number"の形式で表示する。 <ここまで、PNR情報取得API応答.data.contacts.representative.phones[]の要素数繰り返し> */
      return type + phone?.number;
    }
    /**  2.2.1.2 取得できなかった場合、電話番号種別は携帯とする。  */
    return `${this.staticMsg.transform('label.mobilePhone')}${phone?.number}`;
  }

  /** a part of 1-6 代表者電話番号 */
  get isShowTelPhone(): boolean {
    return Boolean(
      this.pnr?.orderType?.channelType !== GetOrderResponseDataOrderType.ChannelTypeEnum.Gds &&
        this.pnr?.orderType?.channelDetail !== GetOrderResponseDataOrderType.ChannelDetailEnum.MerchantNotAnaNdc &&
        this.pnr?.orderType?.isGroupBooking !== true
    );
  }

  /**(2) 「代表者連絡先情報編集」ボタン押下時 */
  clickEditRepresentiveContacts() {
    this._myBookingPassengerService.handleEvents(PassengerInformationInputModalEditArea.REPRESENTATIVE_CONTACT, '');
  }

  destroy(): void {
    this._subscriptions.unsubscribe();
  }
}
